import React from 'react';
import { ResourceProps } from 'react-admin';

// Activos. El catálogo es DUEÑO en el código (lo proyecta el composer al
// arrancar): desde acá no se crean ni se borran monedas. El APR y la palanca se
// tocan en la propia fila, así que tampoco hace falta una ruta de edición.
let resourceProps: ResourceProps = {
  name: 'currencies',
  list: React.lazy(() => import(/* webpackChunkName: "c-activos" */ '../../console/pages/activos')),
};

export default resourceProps;
